import { useEffect, useState } from 'react';
import { History, X } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const fmt = (s) => (s || '').replace('T', ' ').slice(0, 16);

export const RevisionsDialog = ({ record, token, onClose }) => {
  const [revs, setRevs] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/compliance/revisions/${record.id}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json()).then(d => setRevs(Array.isArray(d) ? d : [])).catch(() => setRevs([]));
  }, [record.id, token]);

  return (
    <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-slate-900 border border-slate-700 rounded-2xl w-full max-w-lg max-h-[80vh] overflow-y-auto p-4" onClick={e => e.stopPropagation()} data-testid="revisions-dialog">
        <div className="flex items-center justify-between mb-3">
          <p className="text-white font-semibold flex items-center gap-2"><History size={16} className="text-violet-400" /> Versions — {record.title}</p>
          <button onClick={onClose} className="text-slate-400" data-testid="revisions-close"><X size={18} /></button>
        </div>
        <p className="text-xs text-slate-400 mb-3">Version actuelle : v{record.version}. Les versions précédentes sont conservées telles qu'elles étaient avant chaque correction.</p>
        {revs === null ? <p className="text-slate-500 text-sm">Chargement…</p> : revs.length === 0 ? (
          <p className="text-slate-500 text-sm">Aucune version antérieure.</p>
        ) : revs.map(r => (
          <div key={r.id} className="border border-slate-700/60 rounded-xl p-3 mb-2 text-xs" data-testid={`revision-${r.version}`}>
            <p className="text-violet-300 font-semibold">Version {r.version} (originale{r.version > 1 ? ' corrigée' : ''})</p>
            <p className="text-slate-400 mt-1">Archivée le {fmt(r.archived_at)} — {r.reason}</p>
            <p className="text-slate-500 mt-1">
              Date du document : {r.snapshot?.inspection_date || r.snapshot?.measurement_date || r.snapshot?.date || '—'}
              {r.snapshot?.odometer ? ` · Odomètre ${r.snapshot.odometer} km` : ''}
              {r.snapshot?.summary ? ` · ${r.snapshot.summary.conformes ?? 0} C / ${r.snapshot.summary.mineurs ?? 0} Min / ${r.snapshot.summary.majeurs ?? 0} Maj` : ''}
              {r.snapshot?.axles ? ` · ${r.snapshot.axles.length} essieu(x)` : ''}
            </p>
          </div>
        ))}
        <p className="text-[11px] text-slate-500 mt-2">Le PDF de chaque version est inclus dans le dossier ZIP (dossier « versions »).</p>
      </div>
    </div>
  );
};
